export default "__VITE_ASSET__uZjjpNVD__"